import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_e74jkgmjc2: FaireBrandEntity = {
  token: "b_e74jkgmjc2",
  type: "brand",
  name: "Pavilion",
  avatarUrl:
    "https://cdn.faire.com/fastly/2f0ceac175c6d99f37d48a81d1d5827c4b879311e3ca5fcb67b5893b91c0316c.png",
  bannerUrl:
    "https://cdn.faire.com/fastly/a21bcd0019e0d4dde63996d87249423bf456fa5b7f3e72fc224896a4fb115f53.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/2f0ceac175c6d99f37d48a81d1d5827c4b879311e3ca5fcb67b5893b91c0316c.png",
  heroImageUrl:
    "https://cdn.faire.com/fastly/a21bcd0019e0d4dde63996d87249423bf456fa5b7f3e72fc224896a4fb115f53.jpeg",
  location: "Bergen, NY, USA",
  minimumOrderDollars: 150,
  rating: 4.9,
  reviewCount: 226,
  isInsider: true,
  description:
    "Founded by Rich and Zina Hocker, Pavilion has been distributing high-quality commercial gift products since 1998. Pavilion's office and distribution center is located in Bergen, NY just outside of Rochester. Here, our creative team of professionals develop ideas, design unique gift items, create elegant packaging, and prepare them to be shared with people around the world.",
  meta: {
    source: "api",
    importedAt: "2026-08-15T03:51:33.653Z",
    importedBy: "entity-db-cli",
  },
};
